<template>
  <div>
    <div id="scroll_top_btn"><i class="fa fa-caret-up fa-2x" @click="clickScroll"></i></div>
    <footer>
      <div class="row" style="display:flex;align-items: center;justify-content: center;max-width: 1700px;margin: auto;">
        <div class="row col-xl-12 col-12">
          <div class="col-6 col-sm-4 col-md-4 col-lg-2" style="margin-bottom:30px;">
            <img style="width:96%;margin:0 auto;" src="../../assets/瑞日鏵_LOGO_320x150.png">
          </div>
          <div class="col-6 col-sm-4 col-md-4 col-lg-2" style="margin-bottom:30px;">
            <img style="width:96%;margin:0 auto;" src="../../assets/上聯_LOGO_320x150.png">
          </div>
          <div class="col-6 col-sm-4 col-md-4 col-lg-2" style="margin-bottom:30px;">
            <img style="width:96%;margin:0 auto;" src="../../assets/大通_LOGO_320x150.png">
          </div>
          <div class="col-6 col-sm-4 col-md-4 col-lg-2" style="margin-bottom:30px;">
            <img style="width:96%;margin:0 auto;" src="../../assets/匯巨_LOGO_320x150.png">
          </div>
          <div class="col-6 col-sm-4 col-md-4 col-lg-2" style="margin-bottom:30px;">
            <img style="width:96%;margin:0 auto;" src="../../assets/三三九_LOGO_320x150.png">
          </div>
          <div class="col-6 col-sm-4 col-md-4 col-lg-2" style="margin-bottom:30px;">
            <img style="width:96%;margin:0 auto;" src="../../assets/亞聯_LOGO_320x150.png">
          </div>
        </div>
        <br>
        <div id="footer_left" class="row col-xl-9 col-12">
          <div class="col-md-2 col-12">
            <img src="../../assets/toplink_logo_white.png">
          </div>
          <div class="row col-md-7 col-12" style="margin: auto;">
            <div class="footer_company_intro col-md-6 col-12" v-for="company in companys" :key="company.name">
              <h3>{{company.name}}</h3>
              <p>{{company.address}}</p>
              <p>業務洽詢：<a :href="'mailto:'+company.email">{{company.email}}</a></p>
              <p>線上客服：<a :href="company.fbmsg">messenger/toplink01</a></p>
              <!--<p>電話：{{company.tel}}</p>
              <p>傳真：{{company.fax}}</p>-->
            </div>
          </div>
          <div class="footer_information col-md-3 col-12">
            <h3 style="text-align:center;margin:0;">展覽好康情報站</h3>
            <div>
              <div class="footer_information_icon" v-for="icon in icons" :key="icon.name">
                <div class="footer_icon_box"><a :href="icon.link" target="_blank"><img :src="icon.url" :alt="icon.name"></a></div>
                <p>{{icon.name}}</p>
              </div>
            </div>
          </div>
        </div>
        <!--<hr class="show-in-1200" style="width: 100vw; padding: .5px;margin-top:40px;">-->
        <div id="footer_right" class="row col-xl-3 col-12">
          <div class="col-12">
            <ul>
              <li v-for="item in footerMenu" :key="item.name">
                <a :href="item.url" v-if="item.url.indexOf('http') > -1 || item.url.indexOf('javascript') > -1" target="_blank">{{ item.name }}</a>
                <router-link :to="item.url" tag="a" v-else>{{ item.name }}</router-link>
              </li>
            </ul>
          </div>
          <div class="col-12">
            <p>Copyrights &copy;2022 All Rights Reserved by Top-Link.</p>
          </div>
        </div>
      </div>
    </footer>
    <!-- 手機版置底social_bar -->
    <div id="social_bar">
      <div :class="{'line': isLine(icon),'fb': !isLine(icon), 'button': true}" v-for="icon in icons" :key="icon.name">
        <a :href="icon.link" target="_blank">
          <div>
            <img :src="icon.bar_url">
          </div>
          <p>{{icon.name}}</p>
        </a>
      </div>
    </div>
    <!-- End of 手機版置底social_bar -->
  </div>
</template>

<script>
export default {
  name: 'baseFooter',
  props: {},
  data () {
    return {
      companys: [
        {name: '台北總公司', address: '台北市信義區忠孝東路五段552號11樓', tel: '02-2759-7167', fax: '02-2759-6067', email: '174@top-link.com.tw', fbmsg: 'https://www.messenger.com/t/toplink01'},
        {name: '高雄分公司', address: '高雄市苓雅區三多四路110號17樓-2', tel: '07-331-0188', fax: '07-331-0877', email: '174@top-link.com.tw', fbmsg: 'https://www.messenger.com/t/toplink01'}
      ],
      icons: [
        {name: '北區', url: require('../../assets/line_icon.jpg'), link: 'line://ti/p/@fkt9374f', bar_url: require('../../assets/social_bar/line_icon.png'), type: 'line'},
        {name: '中南區', url: require('../../assets/line_icon.jpg'), link: 'line://ti/p/@kbn7468c', bar_url: require('../../assets/social_bar/line_icon.png'), type: 'line'},
        {name: '粉絲團', url: require('../../assets/fb_icon.jpg'), link: 'https://www.facebook.com/toplink01/', bar_url: require('../../assets/social_bar/fb_like.png'), type: 'fb'}
      ],
      footerMenu: [
        {name: '關於上聯', url: '/about'},
        {name: '廠商專區', url: '/partner'},
        // {name: '聯絡我們', url: 'javascript:alert("敬請期待");'},
        //{name: '聯絡我們', url: 'contact'},
        {name: '全年檔期', url: '/schedule'}, // https://www.top-link.com.tw/tlweb/schedule
        // {name: '會員中心', url: 'https://member.top-link.com.tw/#/card'},
        // {name: '首頁', url: '/'}
        {name: '隱私權政策', url: '/policy'},
        {name: '使用者條款', url: '/tou'}
      ]
    }
  },
  methods: {
    isLine(icon) {
      return icon.type === 'line' ? true : false
    },
    clickScroll() {
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    var scroll_top_btn = document.getElementById('scroll_top_btn')
    if("scrollBehavior" in document.body.style) {
      document.documentElement.style.scrollBehavior = "smooth"
    } else {
      scroll_top_btn.style.display = 'none'
    }
  }
}
</script>

<style lang="sass">
$xl-pc-1200-media: '1200px'
$pc-992-media: '992px'
$pad-768-media: '768px'
$mobile-576-media: '576px'

@mixin xl-pc-width() 
  @media (max-width: $xl-pc-1200-media)
    @content

@mixin pc-width() 
  @media (max-width: $pc-992-media)
    @content

@mixin pad-width() 
  @media (max-width: $pad-768-media)
    @content

@mixin mobile-width() 
  @media (max-width: $mobile-576-media)
    @content

footer 
  color: white
  background: #495057
  padding: 30px 0
  overflow: hidden
#footer_left
  > div:first-child
    display: flex
    align-items: center
    justify-content: center
    img 
      width: 100%
      max-width: 180px
      min-width: 150px
      height: auto
      @include mobile-width 
        width: 65%
        max-width: 180px
  .footer_company_intro
    border-right: 1px solid white
    padding-left: 5%
    box-sizing: border-box
    h3 
      margin: 0
      margin-bottom: 16px
    p 
      font-size: 15px
      a
        color: white
        text-decoration: none
        &:hover
          text-decoration: underline
    p:last-child
      margin-bottom: 0
  .footer_information
    > div 
      display: flex
      justify-content: space-around
  @include pc-width 
    .footer_company_intro
      p 
        font-size: 12px
  @include pad-width 
    > div:first-child
      justify-content: center
      margin-bottom: 15px
    .footer_company_intro
      margin-top: 15px
      padding-left: 15px
      padding-bottom: 15px
      border-right: none
      border-bottom: 1px solid white
      text-align: center
    .footer_information 
      display: none
      /* margin-top: 40px */
      > div
        justify-content: center
  @include mobile-width

.footer_information_icon
  width: 60px
  margin-top: 15px
  position: relative
  .footer_icon_box
    width: 80%
    border-radius: 10px
    margin: auto
    overflow: hidden
  img
    display: block
    max-width: 100%
  
  p 
    font-size: 13px
    position: absolute
    bottom: -30px
    left: -3px
    width: 110%
    text-align: center
  @include pad-width 
    p 
      bottom: -38px

#footer_right 
  div:first-child 
    ul 
      list-style-type: none
      margin: 0
      padding: 0
      width: 100%
      float: right
      margin: 0 0 20px 0
      text-align: center
      li 
        display: inline-block
        a 
          display: block
          margin: 10px 19px
          text-decoration: none
          color: white
          font-size: 18px

  div:nth-child(2) 
    // padding-right: 60px
    p 
      // float: right
      font-size: 13px
      margin: auto
      text-align: center
  @include xl-pc-width 
    margin-top: 30px
    div:first-child
      ul 
        float: none
        width: auto
        text-align: center
        margin: 0
    div:nth-child(2) 
      padding-top: 20px
      padding-right: 0
      padding-left: 0
      p 
        float: none
        text-align: center
        margin: auto
  @include pad-width 
    /*margin-top: 30px*/
    padding-bottom: 40px
    div:first-child 
      ul 
        li 
          a 
            font-size: 15px
            margin: 5px 10px
    div:nth-child(2) 
      p 
        font-size: 12px

// 置頂按鈕
#scroll_top_btn 
  display: inline-block
  position: fixed
  text-align: right
  transition: opacity .5s
  bottom: 50px
  opacity: 0
  right: 0
  z-index: 10
  .fa-caret-up 
    display: inline-block
    background: rgba(0,0,0,0.4)
    padding: 4px 12px
    margin-right: 100px 
    color: white
    border-radius: 3px
    cursor: pointer
  @include mobile-width 
    .fa-caret-up 
      margin-right: 30px

// 置底bar
#social_bar
  position: fixed
  display: none
  justify-content: space-around
  align-items: center
  bottom: 0
  background: rgba(0, 0, 0, 0.4)
  width: 100%
  padding: 5px
  z-index: 2
  .button 
    width: 100px
    border-radius: 10px
    a 
      display: flex
      align-items: center
      text-decoration: none
      color: white
      font-weight: bold
      font-size: 18px
      p 
        margin: 0
        text-align: center
      div 
        img
          display: block
          max-width: 100%
    &.fb
      a 
        padding: 6px
        p 
          width: 70%
        div 
          width: 30%
      background: #3b5998
    &.line
      background: #00b900
      a 
        p 
          width: 60%
        div 
          width: 40%
  @include pad-width 
    display: flex

.show-in-1200
  display: none
  @include xl-pc-width
    display: block
  @include pad-width 
    display: none
</style>
